import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Network } from "lucide-react";
import { api } from "../lib/api";
import { Card } from "./ui/card";

export const StrukturWidget = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/struktur/ringkas").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d || !d.periode) return null;
  return (
    <Card className="p-4 sm:p-5 rounded-2xl border-slate-200/80" data-testid="dashboard-struktur-card">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-3"><div className="h-11 w-11 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center"><Network className="h-5 w-5" /></div>
          <div><div className="text-xs sm:text-sm text-slate-600">Pengurus GKPY Jatinegara</div><div className="text-sm font-semibold text-slate-900" data-testid="dashboard-struktur-periode">{d.periode.nama}</div></div></div>
        <Link to="/struktur-organisasi" className="text-sm font-semibold text-[hsl(224,64%,33%)] hover:underline min-h-[44px] inline-flex items-center" data-testid="dashboard-struktur-link">Lihat Struktur →</Link>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-2">
        {d.pimpinan.map((p) => (
          <div key={p.jabatan} className="rounded-xl border border-amber-200 bg-amber-50/50 p-3" data-testid={`dashboard-struktur-${p.jabatan.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="text-[11px] uppercase tracking-wide text-amber-800 font-semibold">{p.jabatan}</div>
            <div className="text-sm text-slate-900 mt-0.5 leading-snug">{p.personel.length ? p.personel.join(", ") : <span className="text-slate-400 italic">Belum diisi</span>}</div>
          </div>))}
      </div>
    </Card>
  );
};
